import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    Output,
    QueryList,
    SimpleChanges
} from '@angular/core';
import {StepperSectionDirective} from './stepper-section.directive';
import {Subject} from 'rxjs';
import isRequired from '../../decorators/isRequired.decorator';
import {BaseComponent} from '@ui-app/components/base.component';

interface IActiveSectionEmitValue {
    activeSection: number;
    sectionLength: number;
    isFirst: boolean;
    isLast: boolean;
}

@Component({
    selector: 'ui-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.less']
})
export class StepperComponent extends BaseComponent implements AfterContentInit, OnChanges {
    @ContentChildren(forwardRef(() => StepperSectionDirective), {descendants: true}) sectionDirs: QueryList<any>;
    @isRequired()
    @Input() doStepSubject: Subject<boolean>;
    @Input() activeSection: number = 0;
    @Output() onActiveSectionChange: EventEmitter<IActiveSectionEmitValue> = new EventEmitter();

    sections: StepperSectionDirective[] = [];

    get isLastStep(): number {
        return this.sections.filter(section => !section.stepHidden).length - 1;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.activeSection && changes.activeSection.currentValue) {
            this.emitActiveSectionChange(this.activeSection);
        }
    }

    handleHiddenSections(): void {
        this.sections = this.sectionDirs.toArray();
        this.sections.forEach((section, i) => {
            return section.hidden = i !== this.activeSection;
        });
    }

    ngAfterContentInit(): void {
        this.handleHiddenSections();

        this.doStepSubject.subscribe((value: boolean) => {
            this.handleHiddenSections();
            const shownSteps = this.sections.filter(section => !section.stepHidden);

            let nextIdx: number;
            if (value) {
                // To find the next step we take an array of all shown steps and take: active step + 1.
                // Then we find the index of such step in all the steps.
                nextIdx = this.sections.indexOf(shownSteps[this.activeSection + 1]);
            } else {
                // To find the previous step we take active step index in shown steps and subtract 1.
                // Then we find the index of such step in all the steps.
                const activeStepInHiddenArray = shownSteps.indexOf(this.sections[this.activeSection]);
                nextIdx = this.activeSection > 0 ? this.sections.indexOf(shownSteps[activeStepInHiddenArray - 1]) : 0;
            }
            this.goTo(nextIdx);
        });
    }

    goTo(index: number): void {
        // TODO: [if need to use ] (click)="goTo(i)" add to button in template
        if (!this.sections[index] || !this.sections[index].isCanActivate || this.activeSection === index || index < 0) {
            return;
        }
        this.sections[this.activeSection].hidden = true;
        this.activeSection = index;
        this.emitActiveSectionChange(this.activeSection);
        this.sections[this.activeSection].hidden = false;
    }

    emitActiveSectionChange(activeSection: number): void {
        const value = {
            activeSection,
            sectionLength: this.sections.length,
            isFirst: activeSection === 0,
            isLast: activeSection === this.sections.filter(item=> item.stepHidden !== true).length - 1,
        };
        this.onActiveSectionChange.emit(value);
    }
}
